import * as ng from 'angular';

export class MoleculePanelNextcloudDownloadsController implements ng.IController {}

export class MoleculePanelNextcloudDownloadsComponent implements ng.IComponentOptions {
    public controller =  MoleculePanelNextcloudDownloadsController;
    public template = require('./panel-nextcloud-downloads.html');
}
